import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact from '../hooks/__generated__/useDefaultAndSpaceClassificationLevelsQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadDefaultAndSpaceClassificationLevels(spaceKey: string = ''): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query({
		query: UseDefaultAndSpaceClassificationLevelsQueryRelayArtifact,
		variables: {
			spaceKey,
		},
	});
}
